/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : KeyValueDisplayCard.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Typography } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import { componentStyle } from "../../../../config/appTheme";
import CustomToolTip from "../../../../components/infoButton/CustomToolTip";

function KeyValueDisplayCard({ data = [] }) {
  return (
    <Box>
      {(data || []).map((item, index) => {
        const itemKey = item?.key ? `${item.key}-${index}` : index;
        return (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              ...item.style,
            }}
            key={itemKey}
          >
            <CustomToolTip
              title={
                `${item.key}: ${item.value}`.length > 50
                  ? `${item.key}: ${item.value}`
                  : ""
              }
              type={"component"}
            >
              <Typography
                sx={{
                  ...componentStyle.font.text,
                  ...item.style,
                  textAlign: "left",
                  width: "100%",
                }}
              >
                {`${item.key}: ${item.value}`.length > 50
                  ? `${item.key}: ${item.value}`.substring(0, 50) + "..."
                  : `${item.key}: ${item.value}`}
              </Typography>
            </CustomToolTip>
          </Box>
        );
      })}
    </Box>
  );
}

KeyValueDisplayCard.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      style: PropTypes.object,
    }),
  ),
};

export default KeyValueDisplayCard;
